<template>
  <div v-if="learningPaths && learningPaths.length" class="area-paths">
    <div class="area-paths__title-wrapper">
      <Passes :passName="area" :size="32" :showTooltip="false" />
      <h6 class="area-paths__title">{{ area }}</h6>
    </div>
    <div class="area-paths__wrapper">
      <LearningPathTile
        v-for="path in learningPaths"
        :key="path.objectID"
        :path="path"
      />
    </div>
  </div>
</template>

<script>
import { createIndices } from '@/services/search'
import Passes from '@/components/properties/Passes.vue'
import LearningPathTile from '@/components/layout/LearningPathTile.vue'

export default {
  name: 'LearningPathsByLearningArea',
  components: {
    LearningPathTile,
    Passes,
  },
  props: {
    algoliaKeys: {
      type: Object,
      required: true,
    },
    area: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      learningPaths: [],
    }
  },
  methods: {
    handleResults(name, { hits }) {
      this.learningPaths = hits
    },
    createSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, learningPathsIndex: learningPaths },
      } = this
      const setup = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: this.area,
            index: learningPaths,
            facets: ['learning_areas.name'],
          },
        ],
        resultsHandler: this.handleResults,
      }
      const parentFilter = {
        facet: 'learning_areas.name',
        value: this.area,
      }
      createIndices(setup, parentFilter)
    },
  },
  created() {
    this.createSearchInstance()
  },
}
</script>

<style lang="scss">
.area-paths {
  &__title-wrapper {
    display: flex;
    align-items: center;
    padding: 50px 0 20px 0;
  }
  &__title {
    padding: 0;
    color: var(--white);
    margin: -5px 0 0 10px;
    font-family: var(--font-bold);
    text-transform: uppercase;
    font-size: 1rem;
  }
  &__wrapper {
    display: grid;
    grid-template-columns: 1fr;
    gap: 10px;
    @include mobile {
      grid-template-columns: repeat(2, 1fr);
    }
    @include tablet {
      gap: 20px;
      grid-template-columns: repeat(3, 1fr);
    }
    @media (min-width: 1500px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}
</style>
